import store from '../store'
import axiosInstance from '../../axios/axiosInstance'
import {
  SET_CORRECTION_ANSWER,
  SET_CORRECTION_COUNT,
  SET_CORRECTION_DATA,
  SET_CORRECTION_ERRORS,
  SET_CORRECTION_QUESTION,
  SET_CORRECTION_STORY,
} from '../types'

// export const getOldWord = async () => {
//   return await fetch(`${MAAYOT_API}words/past-new-words`, {
//     method: 'GET',
//     headers,
//   }).then((resData) => resData.json())
// }

export const setCorrections = (corrections: any) => {
  store.dispatch({
    type: SET_CORRECTION_DATA,
    payload: corrections,
  })
}

export const GetStudentCorrection = async (perPage: string | number, page: string | number) => {
  try {
    const res = await axiosInstance.get(`story-correction/closed-corrections?par_page=${perPage}&page=${page}`)
    const data = res?.data
    if (data && Object.keys(data) && Object.keys(data).length > 0) {
      const ansData = data.answers.map((ans: any) => ans.data)
      store.dispatch({
        type: SET_CORRECTION_ANSWER,
        payload: data.answers,
      })
      store.dispatch({
        type: SET_CORRECTION_COUNT,
        payload: data.count,
      })
      store.dispatch({
        type: SET_CORRECTION_DATA,
        payload: ansData,
      })
      return {
        Answers: data.answers,
        Data: ansData,
        count: data.count,
      }
    } else {
      store.dispatch({
        type: SET_CORRECTION_ERRORS,
        payload: 'Error',
      })
      throw new Error('Error')
    }
  } catch (error) {
    store.dispatch({
      type: SET_CORRECTION_ERRORS,
      payload: 'Error',
    })
    throw error
  }
}

/**
 * Submissions the teacher has not closed yet. `closed-corrections` deliberately
 * omits them, so without this the page cannot tell "you have never submitted"
 * from "your work is in the queue", and told everyone the former.
 *
 * Throws on failure rather than returning an empty list: an empty queue and an
 * unreachable one lead to different copy, and the caller has to be able to tell
 * them apart (a frontend can be deployed ahead of the backend that serves this).
 */
export const GetPendingCorrections = async (): Promise<any[]> => {
  const res = await axiosInstance.get('story-correction/pending-corrections')
  const answers = res?.data?.answers
  if (!Array.isArray(answers)) throw new Error('Malformed pending corrections response')
  return answers.map((a: any) => a?.data).filter(Boolean)
}

/**
 * Whether the learner has any finished correction, for the header's Corrections link.
 *
 * Kept apart from `GetStudentCorrection` on purpose: that one writes the page's
 * paginated list into the store, and the header asks on every route without
 * overwriting what the corrections page is showing.
 */
export const HasClosedCorrections = async (): Promise<boolean> => {
  const res = await axiosInstance.get('story-correction/closed-corrections?par_page=1&page=1')
  const answers = res?.data?.answers
  if (!Array.isArray(answers)) throw new Error('Malformed closed corrections response')
  return answers.length > 0
}

export const getQuestion = async (id: string, level: string) => {
  try {
    const res = await axiosInstance.get(`question/?storyId=${id}&level=${level?.toLowerCase() || ''}`)
    const data = res?.data
    if (data && !data.status && !data.statusCode && Object.keys(data) && Object.keys(data).length > 0) {
      store.dispatch({
        type: SET_CORRECTION_QUESTION,
        payload: {
          question: data.question,
          questionContent: data.questionContent,
        },
      })
      return
    } else {
      store.dispatch({
        type: SET_CORRECTION_ERRORS,
        payload: 'Error',
      })
      throw new Error('Error')
    }
  } catch (error) {
    store.dispatch({
      type: SET_CORRECTION_ERRORS,
      payload: 'Error',
    })
    throw error
  }
}

export const getStory = async (id: string, level: string) => {
  if (!id || !level) {
    return Promise.reject('Invalid params')
  }

  try {
    const resData = await axiosInstance.get(`prismic/findStory?storyId=${id}&level=${level.toLowerCase()}`)
    const dataStory = resData.data
    if (!dataStory || JSON.stringify(dataStory) === '{}') {
      store.dispatch({
        type: SET_CORRECTION_ERRORS,
        payload: 'Story not found',
      })
      store.dispatch({
        type: SET_CORRECTION_STORY,
        payload: null,
      })
      throw new Error('Story not found')
    }

    dataStory.arSentencesWord11 = dataStory?.arSentencesWord11 ? dataStory.arSentencesWord11 : []
    dataStory.arSentencesWord12 = dataStory?.arSentencesWord12 ? dataStory.arSentencesWord12 : []
    dataStory.arSentencesWord21 = dataStory?.arSentencesWord21 ? dataStory.arSentencesWord21 : []
    dataStory.arSentencesWord22 = dataStory?.arSentencesWord22 ? dataStory.arSentencesWord22 : []

    dataStory.storyContent = dataStory.arContentWithTags
    dataStory.arWordSen11 = dataStory.arSentencesWord11.map((word: any) => word.word)
    dataStory.arWordSen12 = dataStory.arSentencesWord12.map((word: any) => word.word)
    dataStory.arWordSen21 = dataStory.arSentencesWord21.map((word: any) => word.word)
    dataStory.arWordSen22 = dataStory.arSentencesWord22.map((word: any) => word.word)
    dataStory.arContent = [
      ...dataStory.arContent,
      ...dataStory.arSentencesWord11,
      ...dataStory.arSentencesWord12,
      ...dataStory.arSentencesWord21,
      ...dataStory.arSentencesWord22,
    ]
    // let oldWords
    // if (oldWordRes?.length) {
    //   oldWords = []
    //   oldWordRes.forEach((wordObj) => {
    //     const { data = {} } = wordObj || {}
    //     const { word, level: objLevel } = data || {}
    //     if (objLevel?.toLowerCase() == level.toLowerCase()) {
    //       oldWords.push(word)
    //     }
    //   })
    // }
    store.dispatch({
      type: SET_CORRECTION_STORY,
      payload: { ...dataStory },
    })
    // dispatch({
    //   type: SET_LAST_STEP,
    //   payload: lastStep?.data?.[0]?.data?.step,
    // })
    return { ...dataStory }
  } catch (err) {
    store.dispatch({
      type: SET_CORRECTION_ERRORS,
      payload: 'Story not found',
    })
    store.dispatch({
      type: SET_CORRECTION_STORY,
      payload: null,
    })
    throw err
  }
}
